import React from "react";
export default function Footer() {
  return (
    <footer className="site-footer site-footer-microsite">
      <div className="site-footer-inner">
        <div className="site-footer-microsite-secondary">
          <div className="site-footer-microsite-copyright">&copy; {new Date().getFullYear()} American Society of Civil Engineers</div>
        </div>
      </div>
    </footer>
  );
}
